<template>
    <div>
        <div class="field-label" style="padding-top: 0.4rem">
            {{ inputValue }}
            <router-link v-if="errors.has($attrs['data-vv-name'])" :to="{ name: 'profile', hash: '#settings' }">
                {{ "payment system.actions.fill profile" | translate }}
                <span class="icon" style="vertical-align: bottom">
                    <i class="fas fa-external-link-alt"></i>
                </span>
            </router-link>
            <input :value="inputValue"
                   :class="[{ 'is-danger': errors.has($attrs['data-vv-name']) }, 'input']"
                   v-show="false"
                   v-bind="$attrs"
                   v-validate="'phoneNumberProfile|phoneNumberMpesa'"
                   readonly />
        </div>
    </div>
</template>

<script>
    import Vue from "vue";

    export default {
        name: "phone-number-mpesa",
        inject: ["$validator"],
        props: {
            inputValue: { required: true, default: "" }
        },
        computed: {
            player: function() {
                return Vue.state.player.get();
            }
        },
        created() {
            this.$validator.extend("phoneNumberProfile", {
                getMessage: () => this.$t("payment system.validation.phone number.profile"),
                validate: () => ({ valid: this.inputValue && this.inputValue.trim().length, data: { required: true } })
            }, { computesRequired: true });

            this.$validator.extend("phoneNumberMpesa", {
                getMessage: () => this.$t("payment system.validation.phone number.format mask", ["254XXXXXXXXX"]),
                validate: () => /^254\d{9}$/.test(this.inputValue)
            });
        },
        mounted() {
            this.$emit("update:inputValue", this.player.phoneNumber);
        }
    };
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/payments/phone-number-mpesa.vue